import { Box, Typography } from "@mui/material";
import React from "react";
import { useRecordContext, useTranslate } from "react-admin";

import { ContentKindIcon } from "./ContentKindIcon";

type ContentTitleFieldProps = {
  label?: string;
  iconSize?: number;
};

export const ContentTitleField: React.FC<ContentTitleFieldProps> = ({ iconSize = 24 }) => {
  const record = useRecordContext();
  const translate = useTranslate();
  const contentTitle = record?.contentTitle;
  const contentTitleKey = record?.contentTitleKey;
  const contentKind = record?.cmsContentKind;

  if (!contentTitle && !contentTitleKey) {
    return null;
  }

  const displayTitle = contentTitleKey ? translate(contentTitleKey, { _: contentTitle }) : contentTitle;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {contentKind && <ContentKindIcon contentKind={contentKind} size={iconSize} />}
      <Typography variant="body2">{displayTitle}</Typography>
    </Box>
  );
};
